import React, { useState, useRef, useLayoutEffect } from 'react';

import { Link } from 'gatsby';
import slugify from 'slugify';

import CDNImage from '../../common/cdn-image';
import { IconArrowLeftSvg, IconArrowRightSvg } from '../../common/svg';

import '../../../styles/shop/themed-sets-drawer.scss';

const buildThemedSetLinkPath = (name, sortSlug) => {
  let path = `/shop/fine-art-prints/themed-set/${slugify(name).toLowerCase()}/`;

  if (sortSlug) {
    path += `${sortSlug}/`;
  }

  return path;
};

const carouselDisplayStep = (drawerContentsRef) => {
  const carouselCell = drawerContentsRef.current.querySelector('.themed-sets-drawer__cell');

  return carouselCell.offsetWidth;
}

const drawerContentsOffset = (carouselPosition, drawerContentsRef) => {
  if (carouselPosition === 0) {
    return 0;
  }

  return `-${ carouselDisplayStep(drawerContentsRef) * carouselPosition }px`;
};

const showBackButton = (carouselPosition) => {
  return carouselPosition > 0;
}

const showForwardButton = (carouselPosition, drawerContainerRef, drawerContentsRef) => {
  if (drawerContentsRef.current && drawerContainerRef.current) {
    const cellWidth = carouselDisplayStep(drawerContentsRef);

    return (drawerContentsRef.current.scrollWidth - (cellWidth * carouselPosition)) > drawerContainerRef.current.offsetWidth;
  }

  return false;
}

const showLeftScreen = (carouselPosition) => {
  return carouselPosition > 0;
};

const showRightScreen = (carouselPosition, drawerContainerRef, drawerContentsRef) => {
  if (drawerContentsRef.current && drawerContainerRef.current) {
    const cellWidth = carouselDisplayStep(drawerContentsRef);

    return (drawerContentsRef.current.scrollWidth - (cellWidth * carouselPosition)) > drawerContainerRef.current.offsetWidth;
  }

  return false;
};

const ThemedPrintSets = (props) => {
  let themedSets = [];
  for (let i = props.themedSets.edges.length - 1; i >= 0; i--) {
    themedSets.push(props.themedSets.edges[i]);
  }

  const drawerContainerRef = useRef();
  const drawerContentsRef = useRef();

  const [carouselPosition, setCarouselPosition] = useState(0);
  const [leftScreenVisible, setLeftScreenVisible] = useState(false);
  const [rightScreenVisible, setRightScreenVisible] = useState(false);
  const [backButtonVisible, setBackButtonVisible] = useState(false);
  const [forwardButtonVisible, setForwardButtonVisible] = useState(false);

  useLayoutEffect(() => {
    const updateControls = () => {
      setLeftScreenVisible( showLeftScreen(carouselPosition) );
      setRightScreenVisible( showRightScreen(carouselPosition, drawerContainerRef, drawerContentsRef) );
  
      setBackButtonVisible( showBackButton(carouselPosition) );
      setForwardButtonVisible( showForwardButton(carouselPosition, drawerContainerRef, drawerContentsRef) );
    };
    
    updateControls();

    window.addEventListener('resize', updateControls);

    return () => window.removeEventListener('resize', updateControls);
  }, [carouselPosition]);

  return (
    <div
      ref={drawerContainerRef}
      className="themed-sets-drawer"
    >
      <div
        className="themed-sets-drawer__frame"
      >
        <div
          ref={drawerContentsRef}
          className="themed-sets-drawer__contents"
          style={ { left: drawerContentsOffset(carouselPosition, drawerContentsRef) } }
        >
          {themedSets.map(({ node }) => (
            <div
              className="themed-sets-drawer__cell"
              key={ node.data.Reference }
            >
              <div className="themed-sets-drawer__cell-frame">
                <Link to={ buildThemedSetLinkPath(node.data.Name, props.sortSlug) }>
                  <div className="themed-sets-drawer__image-bucket">
                    <CDNImage
                      imagePath={ node.data.Image_Path }
                    />
                  </div>
                  <span className="themed-sets-drawer__title">
                    { node.data.Name }
                  </span>
                </Link>
              </div>
            </div>
          ))}
        </div>
        {leftScreenVisible && <div className="themed-sets-drawer__left-screen" />}
        {rightScreenVisible && <div className="themed-sets-drawer__right-screen" />}
      </div>
      {backButtonVisible && (
        <button
          className="themed-sets-drawer__left-control"
          onClick={() => {
            setCarouselPosition(carouselPosition - 1);
          }}
        >
          { IconArrowLeftSvg }
        </button>
      )}
      {forwardButtonVisible && (
        <button
          className="themed-sets-drawer__right-control"
          onClick={() => {
            setCarouselPosition(carouselPosition + 1);
          }}
        >
          { IconArrowRightSvg }
        </button>
      )}


    </div>
  );
}

export default ThemedPrintSets;